import { useMemo } from 'react';
import { useBaseFilter, useFilter } from '../../../../hooks/useFilter';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getMembers } from '../../../../store/team/selectors';
import { getSelectedLocationId } from '../../../../store/schedules/selectors';
import { getSelectedFilterItems } from '../../../../store/common/selectors';

export function useScheduleFilters() {
  const {
    filterByPermissions,
    filterByDepartments,
    filterByPositions,
    filterByLocations,
  } = useFilter();
  const { baseFilters } = useBaseFilter();
  const members = useAppSelector(getMembers);
  const selectedFilterItems = useAppSelector(getSelectedFilterItems);
  const selectedLocationId = useAppSelector(getSelectedLocationId);

  const getMembersByFilters = useMemo(() => {
    let filteredMembers = members;

    if (selectedFilterItems.role?.length) {
      filteredMembers = filterByPermissions(members);
    }

    if (selectedFilterItems.department?.length) {
      filteredMembers = filterByDepartments(members);
    }

    if (selectedFilterItems.position?.length) {
      filteredMembers = filterByPositions(members);
    }

    if (selectedFilterItems.location?.length) {
      filteredMembers = filterByLocations(members);
    }

    if (selectedLocationId > 0) {
      filteredMembers = filteredMembers.filter((member) => member.locations.some((location) => location.id === selectedLocationId));
    }

    return filteredMembers;
  }, [members, selectedFilterItems, selectedLocationId]);

  return {
    schedulesFilterItems: baseFilters,
    getMembersByFilters,
  };
}
